import { render, staticRenderFns } from "./BoardPostList.vue?vue&type=template&id=581d129c&scoped=true"
import script from "./BoardPostList.vue?vue&type=script&lang=js"
export * from "./BoardPostList.vue?vue&type=script&lang=js"
import style0 from "./BoardPostList.vue?vue&type=style&index=0&id=581d129c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d129c",
  null
  
)

export default component.exports